import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export const CodeResentInfo = () => {
    const { t } = useTranslation();

    return (
        <Alert data-testid="code-resent-info" severity="info">
            {t('codeResentInfo.sentNewText')}
        </Alert>
    );
};
